import { sendNotification } from "shared/components/feedback/notification/notification";
import PropTypes from "prop-types";
import VStack from "shared/components/layout/stack/VStack";
import Form from "shared/components/inputs/form/Form";
import Text from "shared/components/data-display/text/Text";
import ModalActions from "shared/components/feedback/modals/ModalActions";

import useHolidays from "features/admin/holidays/useHolidays";

const HolidayDeleteForm = ({ holidayIdToDelete, onClose }) => {
    const { holidays, deleteHoliday } = useHolidays();

    const currentHolidayData = holidays.data?.find(
        (holiday) => holiday.Date === holidayIdToDelete
    );

    if (!currentHolidayData) {
        return <div>Could not find holiday</div>;
    }

    const modifier = deleteHoliday;

    const onSubmit = async () => {
        const clientData = {
            OfficeId: currentHolidayData.OfficeId,
            Date: holidayIdToDelete,
        };
        await modifier.mutateAsync(clientData);
        onClose();
        sendNotification(
            <>
                <strong> {currentHolidayData.Name} </strong> has been
                deleted
            </>
        );
    };
    return (
        <Form onSubmit={onSubmit}>
            <VStack spacing="Three">
                <Text variant="Body_1_1" color="Gray_2">
                    <strong> {currentHolidayData.Name} </strong> will be
                    deleted.
                </Text>
                <ModalActions
                    primaryAction={{
                        type: "submit",
                        label: "Yes, Delete",
                    }}
                    secondaryAction={{
                        type: "button",
                        label: "Cancel",
                        to: "?action=edit&id=" + holidayIdToDelete,
                    }}
                />
            </VStack>
        </Form>
    );
};

HolidayDeleteForm.propTypes = {
    holidayIdToDelete: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired
};

export default HolidayDeleteForm;
